import { ViewChild, AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'tpc-slider',
    templateUrl: './range.component.html',
    styleUrls: ['./range.component.css']
})
export class RangeComponent implements AfterViewInit {
    public _value: Array<number> = [33, 66];
    public range2config: any = {
        connect: true,
        animate: false,
        step: 1,
        range: {
            min: 0,
            max: 100
        }
    };
    @ViewChild('nouislider') nouislider: any;

    @Output() change = new EventEmitter<Array<number>>();
    @Input() set value(data: Array<number>) {
        this._value = data;
    };

    ngAfterViewInit() {
        let self = this;
        this.nouislider.slider.on('slide', (value) => {
            self._value = value;
            self.change.emit(self._value);
        });
    }

    getShortFlights(): string {
        return this._value[0] + '%';
    }

    getMedFlights(): string {
        return (this._value[1] - this._value[0]) + '%';
    }

    getLongFlights(): string {
        return (100 - this._value[1]) + '%';
    }

}



// WEBPACK FOOTER //
// ./src/app/components/range/range.component.ts